import {ref} from 'vue'

/**
 * Use value toggle
 */
export function useValueToggle(initialValue = false) {

  //Create refs
  const isValue = ref(initialValue)

  //Set value
  const setValue = value => isValue.value = Boolean(value)
  const setTrue = () => setValue(true)
  const setFalse = () => setValue(false)

  //Toggle value
  const toggleValue = () => {
    if (!isValue.value) {
      setTrue()
    }
    else {
      setFalse()
    }
  }

  //Expose interface
  return {

    //Refs
    isValue,

    //Functions
    setTrue,
    setFalse,
    setValue,
    toggleValue,
  }
}
